import { render } from "./LayoutsAuthSidebarContentMenu.vue?vue&type=template&id=15651d8f&ts=true"
import script from "./LayoutsAuthSidebarContentMenu.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthSidebarContentMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__